import { memo, type ReactNode } from 'react';

export type ActionsCellWrapperProps = {
  children?: ReactNode;
};

export const ActionsCellWrapper = memo(function ActionsCellWrapper({
  children,
}: ActionsCellWrapperProps) {
  return (
    <div className='inline-flex items-center gap-2' data-table='prevent'>
      {children}
    </div>
  );
});
